<div class="d-flex h-100 w-100">
  <div class="ms-auto d-flex align-items-center h-100">
    <div class="nav-item cursor-pointer me-3" (click)="triggerOpenPanel()">
      <app-notification-bell></app-notification-bell>
    </div>
  </div>
</div>
